import React, { Component } from 'react';
import Error500 from "components/Error500";
import PropTypes from 'prop-types';
import Log from "services/Log";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = { hasError: false };
    }

    componentDidCatch(error) {
        this.setState({ hasError: true });

        Log.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            return <Error500 className='error-boundary-wrap' />;
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
        PropTypes.node
    ])
};


export default ErrorBoundary;


